module.exports = __webpack_public_path__ + "static/img/logo.c9fe72a6.png";